import { render, staticRenderFns } from "./Finiquito.vue?vue&type=template&id=6840c3a9&lang=pug&"
import script from "./Finiquito.vue?vue&type=script&lang=js&"
export * from "./Finiquito.vue?vue&type=script&lang=js&"
import style0 from "./Finiquito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Finiquito.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VFlex,
  VLayout,
  VTextField,
})
